import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { useViewerHasAtLeastAdminRights } from "@/lib/rights/use-viewer-has-right.ts";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@babackapp/ui/components/card";
import { Separator } from "@babackapp/ui/components/separator";
import { Fragment } from "react/jsx-runtime";
import AddWebhookDialog from "./add-webhook-dialog.tsx";
import WebhooksListItem from "./webhooks-list-item.tsx";

export default function WebhooksList() {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();
  const webhooks = shop.webhooks;

  const canAddWebhook = useViewerHasAtLeastAdminRights();

  return (
    <Card>
      <CardHeader className="flex flex-row justify-between">
        <div className="flex flex-1 flex-col gap-2">
          <CardTitle className="text-lg leading-6 font-medium text-gray-900">
            {t("settings.integrations.webhooks.title")}
          </CardTitle>
          <CardDescription>
            {t("settings.integrations.webhooks.subtitle")}
          </CardDescription>
        </div>

        {canAddWebhook && (
          <AddWebhookDialog>
            <Button>{t("settings.integrations.webhooks.add")}</Button>
          </AddWebhookDialog>
        )}
      </CardHeader>
      <CardContent>
        <div className="flex flex-col">
          {webhooks?.map((webhook, index) => (
            <Fragment key={index}>
              {index > 0 && <Separator className="my-1" />}
              <WebhooksListItem key={webhook.url} webhook={webhook} />
            </Fragment>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
